(function () {
  gsap.registerPlugin(ScrollTrigger);

  let revealContainers = document.querySelectorAll(".reveal__container");

  revealContainers.forEach((container) => {
    let image =
      container.querySelector("img") || container.querySelector("video");
    let cover = container.querySelector("span");
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        toggleActions: "restart none none reset",
      },
    });

    tl.set(container, { autoAlpha: 1 });
    tl.from(container, 0.5, {
      xPercent: -100,
      delay: 0.5,
      ease: Power2.out,
    });
    tl.to(cover, 0.5, {
      xPercent: 100,
      ease: Power2.out,
    });
    tl.from(image, 1, {
      scale: 1.3,
      delay: -0.5,
      ease: Power2.out,
    });
  });
})();
